<template>
  <div class="flex flex-col">
    <el-descriptions label-class-name="desc-label" class="description" :column="3" border>
      <el-descriptions-item label="药库编码">
        {{ pageData.prescription.head['positionCode'] }}
      </el-descriptions-item>
      <el-descriptions-item label="药库名称">
        {{ pageData.prescription.head['positionName'] }}
      </el-descriptions-item>
      <el-descriptions-item label="加工方式">
        {{ pageData.prescription.head['serveFeeSign'] |SERVE_FEE_SIGN }}
      </el-descriptions-item>
      <el-descriptions-item label="总剂数">
        {{ pageData.prescription.head['doseNum'] }}
      </el-descriptions-item>
      <el-descriptions-item label="次/日">
        {{ pageData.prescription.head['dayNum'] }}
      </el-descriptions-item>
      <el-descriptions-item label="剂/日">
        {{ pageData.prescription.head['dayFreq'] }}
      </el-descriptions-item>
    </el-descriptions>
    <el-table
      :stripe="true"
      :border="true"
      :data="pageData.prescription.body.chmedPrescriptionItem"
      class="ik-list-table"
      :height="300"
      :highlight-current-row="true"
    >
      <el-table-column
        align="center"
        label="药品编码"
        prop="materielName"
      />
      <el-table-column
        align="center"
        label="品质标识"
        prop="qualitySign"
      >
        <template #default="scope">
          <span>
            {{ scope.row["qualitySign"]|QUALITY_SIGN }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="单剂数量"
        prop="singleNum"
      />
      <el-table-column
        align="center"
        label="煎法"
        prop="decoctionName"
      />
    </el-table>
  </div>
</template>
<script>

export default {
  name: "PrescriptionInfo",
  inject: ["pageData"],
  filters: {
    SERVE_FEE_SIGN(sign) {
      switch (sign) {
        case "00":
          return "不加工"
        case "01":
          return "代煎"
        case "11":
          return "制粒"
        case "21":
          return "细粉打粉"
        case "22":
          return "粗粉打粉"
        case "31":
          return "水丸制丸"
        case "32":
          return "蜜丸制丸"
        case "33":
          return "大蜜丸制丸"
        case "35":
          return "水蜜丸制丸"
        case "41":
          return "制瓶装膏"
        case "42":
          return "制袋装膏"
        case "43":
          return "制块装膏"
      }
    },
    /**
     * 质量标识
     * @param sign
     * @returns {string}
     * @constructor
     */
    QUALITY_SIGN(sign) {
      switch (sign) {
        case "1":
          return "普通"
        case "2":
          return "精品"
        default:
          return ""
      }
    }
  }
}
</script>

<style scoped lang="scss">
.description {
  margin-bottom: 20px;
}

::v-deep .desc-label {
  width: 120px;
}

::v-deep .el-table__body-wrapper {
  height: 200px;
}
</style>
